import { useMemo } from 'react'
import { useFirestoreGeneralTwo } from '../firebase/useFirestore'

/**
 * Fetches the goal (Kpis Type 'output') for one output, excluding soft-deleted
 * goals. An output goal is a target number + deadline.
 *
 * @param {string} outputId - Outputs.ID to load the goal for
 * @returns {{ goal: object | null, loading: boolean }}
 */
const useOutputGoal = (outputId) => {
    const docs = useFirestoreGeneralTwo('Kpis', 'OutputID', outputId || '', 'Type', 'output')

    const loading = docs === ''

    const goal = useMemo(() => {
        if (!Array.isArray(docs)) return null
        const live = docs.filter((doc) => doc.Deleted !== 'true' && doc.Deleted !== true)
        return live[live.length - 1] || null
    }, [docs])

    return { goal, loading }
}

export { useOutputGoal }
